// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"82":"nl-NL-lang-js","487":"fr-FR-lang-js","564":"es-ES-lang-js","612":"it-IT-lang-js","958":"en-GB-lang-js","967":"de-DE-lang-js"}[chunkId] + "-legacy." + {"82":"a2cf811e","487":"b13364f5","564":"fe719dee","612":"c5d959ad","958":"ce46b50e","967":"c67a444c"}[chunkId] + ".js";
};